import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react'
import { apiClient } from '../../helpers/Axios';

function HotUpdate() {

    const [hotUpdate, setHotUpdate] = useState()

    const { data, isLoading } = useQuery({
        queryKey: ['hot-update'],
        queryFn: async () => {
            const res = await apiClient.get('/shop/hot-update');
            return res.data;
        }
    })

    useEffect(() => {
        setHotUpdate(data || {})
    }, [data])


    if (!isLoading) {
        return (
            <div style={{ display: hotUpdate?.enabled ? 'block' : 'none' }} className={`w-full text-center py-0.5 bg-secondary text-sm text-white`}>
                <p>{hotUpdate?.message}</p>
            </div>
        )
    }
}

export default HotUpdate